<div class="page-container p-2">
  <app-status-message
    class="d-column h-100"
    title="Pagamento realizado!"
    body="Foi um prazer atender você. Que tal avaliar sua experiência?"
    illustration="happyCheck"
    [footerButtonProps]="{ label: 'Ok, combinado' }"
    (footerButtonClick)="goToStart()"
  >
    <status-message-content class="d-column gap-2 mt-2">
      <mnt-button
        label="Avaliar experiência"
        variant="regular"
        icon-left="starOutline"
        color="neutral"
        size="large"
        (buttonClick)="handleEvaluateExperience()"
        [disabled]="googleBusinessUrl === null"
      ></mnt-button>

      <mnt-button
        label="Abrir comprovante"
        [variant]="googleBusinessUrl ? 'plain' : 'regular'"
        icon-left="receipt"
        color="neutral"
        size="large"
        (buttonClick)="handleOpenReceipt()"
      ></mnt-button>
    </status-message-content>
  </app-status-message>
</div>
